import { createFileRoute } from '@tanstack/react-router';
import { PersonalSettingsRoute } from './-route-wrappers';

// Index route only: `/settings/personal/security` must keep falling through to the
// `_authenticated.settings.$` catch-all (the embedded Ember app owns it).
export const Route = createFileRoute('/_authenticated/settings/personal/')({
  component: PersonalSettingsRoute,
});
